module.exports = __webpack_public_path__ + "images/290412238129cb1ec113f8e78d12831f3.svg";